import { getOzonRedirectStaticUri, OZON_OAUTH_API_URL } from '../const';

export const getOzonOauthUrl = ({
    client_id,
    scope,
    state_token,
}: {
    client_id: string;
    scope?: string[];
    state_token: string;
}) => {
    const params = new URLSearchParams();
    const scopeString = (scope || []).join(' ');

    params.set('response_type', 'code');
    params.set('access_type', 'offline');
    params.set('client_id', client_id);
    params.set('redirect_uri', getOzonRedirectStaticUri());
    params.set('scope', scopeString);
    params.set('state', state_token);

    return `${OZON_OAUTH_API_URL}?${params.toString()}`;
};
